import { render, staticRenderFns } from "./DT_StatsModal.vue?vue&type=template&id=39c54f56&"
import script from "./DT_StatsModal.vue?vue&type=script&lang=js&"
export * from "./DT_StatsModal.vue?vue&type=script&lang=js&"
import style0 from "./DT_StatsModal.vue?vue&type=style&index=0&id=39c54f56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports